// extracted by mini-css-extract-plugin
export default {"page":"DataPrivacy_page__Ol72E"};